import { Pipe, PipeTransform } from '@angular/core';
import { Entity, EntityNameFormatOptions } from 'src/app/models/entities.model';



@Pipe({
  name: 'gioEntityName',
  pure: false
})
export class GioEntityNamePipe implements PipeTransform {

  transform(entity: Entity, options: EntityNameFormatOptions, onEmpty = ''): string {
    if (!options?.default && onEmpty) {
      options.default = onEmpty;
    }
    return Entity.getFormattedName(entity, options);
  }

}
